import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _Map from "@babel/runtime-corejs2/core-js/map";
import _objectSpread from "@babel/runtime-corejs2/helpers/esm/objectSpread";
import axios from 'axios';
import get from 'lodash/get';
import { buildUrl, callAxios, http, getHeaders, getBaseUrl, isClientSide, isGetRequest } from './utils';

var Ajv = require('ajv');

var ajv = new Ajv();
/**
 * This functions create an instance of axios interface
 * @param {Object} config
 * @returns Object with following apis():-
 */

var createHttpClient = function createHttpClient(config) {
  var cacheList = get(config, 'cacheList', []);
  var baseURL = getBaseUrl(config);

  var setupOptions = _objectSpread({
    baseURL: baseURL
  }, config);

  var instance = axios.create(setupOptions);
  var clientCache = new _Map();
  /**
   *
   * This method retrieves cached response
   * @param {string} fetchUrl
   * @returns {object | undefined} cachedResult
   */

  var getCachedResult = function getCachedResult(fetchUrl, axiosOptions) {
    var isClient = isClientSide();

    if (isClient && !(axiosOptions && axiosOptions.updateCache) && clientCache.has(fetchUrl)) {
      // provide cached result unless specified in the config with noCache property
      return clientCache.get(fetchUrl);
    }

    return undefined;
  };
  /**
   *
   * This method stores response in cache
   * @param {Object} responseData
   * @param {string} fetchUrl
   * @param {string} url
   * @private
   */


  var storeInCache = function storeInCache(responseData, fetchUrl, url) {
    var isClient = isClientSide();

    if (isClient && cacheList.includes(url)) {
      clientCache.set(fetchUrl, responseData);
    }
  };
  /**
   *
   * This method is the primary method for initiating http calls
   * @param {string} url
   * @param {Object} axiosOptions
   * @returns
   */


  var request =
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(url, axiosOptions) {
      var reqOptions, schema, fetchUrl, cachedResult, responseData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              reqOptions = axiosOptions || {};
              schema = reqOptions.schema;
              fetchUrl = buildUrl(url, config);

              if (reqOptions && reqOptions.https === false) {
                fetchUrl = http(fetchUrl);
              }

              reqOptions.headers = getHeaders(config, reqOptions);
              reqOptions.url = fetchUrl; // cache only get calls

              if (!isGetRequest(reqOptions)) {
                _context.next = 10;
                break;
              }

              cachedResult = getCachedResult(fetchUrl, reqOptions);

              if (!cachedResult) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return", cachedResult);

            case 10:
              _context.next = 12;
              return callAxios(instance, reqOptions);

            case 12:
              responseData = _context.sent;

              if (!responseData.data) {
                _context.next = 18;
                break;
              }

              if (!(schema && !ajv.validate(schema, responseData.data))) {
                _context.next = 16;
                break;
              }

              throw ajv.errors[0];

            case 16:
              if (isGetRequest(reqOptions)) {
                storeInCache(responseData, fetchUrl, url);
              }

              return _context.abrupt("return", responseData);

            case 18:
              throw responseData;

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function request(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  var axiosInterface = {
    request: request,
    axiosInstance: instance,
    CancelToken: axios.CancelToken,
    interceptors: instance.interceptors
  };
  ['delete', 'get', 'head', 'options'].forEach(function (method) {
    axiosInterface[method] =
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(url) {
        var options,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
                options.method = method; // eslint-disable-line no-param-reassign

                return _context2.abrupt("return", request(url, options));

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      return function (_x3) {
        return _ref2.apply(this, arguments);
      };
    }();
  });
  ['post', 'put', 'patch'].forEach(function (method) {
    axiosInterface[method] =
    /*#__PURE__*/
    function () {
      var _ref3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(url, data) {
        var options,
            _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                options = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : {};
                options.method = method; // eslint-disable-line no-param-reassign

                options.data = data; // eslint-disable-line no-param-reassign

                return _context3.abrupt("return", request(url, options));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      return function (_x4, _x5) {
        return _ref3.apply(this, arguments);
      };
    }();
  });
  return axiosInterface;
};

export default createHttpClient;